<template>
	<form class="form-horizontal">
		<fieldset>
			<div class="form-group">
				<label class="col-md-4 control-label" for="radios-0" style="text-align: right">Hauptadresse</label>
				<div class="col-md-4">
					<label class="radio-inline" for="radios-0">
						<input name="radios" id="radios-0" value="true" :checked="model.model.is_main" type="radio" @click="model.model.is_main = true">
						Ja
					</label>
					<label class="radio-inline" for="radios-1">
						<input name="radios" id="radios-1" value="false" :checked="!model.model.is_main" type="radio" @click="model.model.is_main = false">
						Nein
					</label>
				</div>
			</div>

			<!-- Select Basic -->
			<div class="form-group">
				<label class="col-md-4 control-label text-right" for="selectbasic" style="text-align: right">Art</label>
				<div class="col-md-4">
					<select id="selectbasic" name="selectbasic"  class="form-control" v-model="model.model.address_type">
						<option v-for="kind in $store.getters.models('address_types')" :value="kind.id">{{ kind.name }}</option>
					</select>
				</div>
			</div>

			<!-- Text input-->
			<div class="form-group">
				<label class="col-md-4 control-label" for="textinput" style="text-align: right">Straße</label>
				<div class="col-md-4">
					<input id="textinput" name="textinput" placeholder="" class="form-control input-md" v-model="model.model.street">
				</div>
			</div>

			<!-- Text input-->
			<div class="form-group">
				<label class="col-md-4 control-label" for="textinput" style="text-align: right">Hausnummer</label>
				<div class="col-md-4">
					<input id="textinput" name="textinput" placeholder="" class="form-control input-md" type="text" v-model="model.model.number">
				</div>
			</div>

			<!-- Text input-->
			<div class="form-group">
				<label class="col-md-4 control-label" for="textinput" style="text-align: right">Postleitzahl</label>
				<div class="col-md-4">
					<model-list-select :list="$store.getters.models('zips')"
									   v-model="selectedZip"
									   option-value="zip"
									   option-text="zip"
									   :custom-text="computeZip">
					</model-list-select>
				</div>
			</div>
		</fieldset>
	</form>
</template>

<script>
import Address from "models/addresses.js"
import { ModelListSelect } from 'vue-search-select'

export default {
	data () {
		return {
			model: Address
		}
	},

	mounted () {
		this.$store.dispatch('loadModel', 'zips')
	},

	computed: {
		selectedZip: {
			get () {
				return {
					"zip": this.model.model.zip,
					"city": this.model.model.city
				}
			},

			set (aModel) {
				this.model.model.zip = aModel.zip
				this.model.model.city = aModel.city
			}
		}
	},

	methods: {
		computeZip (aModel) {
			return aModel.zip + " " + aModel.city
		}
	},

	components: {
		ModelListSelect
	}
}
</script>


// WEBPACK FOOTER //
// address-content.vue?0f29138e